package ui.theme

// Theme Mode State
enum class ThemeMode {
    LIGHT, DARK, AUTO
}
